import { render, staticRenderFns } from "./UserTransferConfirmDialog.vue?vue&type=template&id=43530aa8&scoped=true&"
import script from "./UserTransferConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./UserTransferConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserTransferConfirmDialog.vue?vue&type=style&index=0&id=43530aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43530aa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VRow})
